/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Feature, FeatureCollection, Geometry, GeometryCollection, Position } from 'geojson';

export function getGeoJSONBounds(geojson: FeatureCollection | Feature | Geometry) {
  let minLng = Infinity;
  let minLat = Infinity;
  let maxLng = -Infinity;
  let maxLat = -Infinity;

  function processPosition(pos: Position) {
    const [lng, lat] = pos;
    if (lng < minLng) minLng = lng;
    if (lat < minLat) minLat = lat;
    if (lng > maxLng) maxLng = lng;
    if (lat > maxLat) maxLat = lat;
  }

  function processCoords(coords: any) {
    // If the first element is a number, coords is a Position
    if (typeof coords[0] === 'number') {
      processPosition(coords as Position);
    } else {
      (coords as Array<any>).forEach(processCoords);
    }
  }

  function processGeometry(geom: Geometry | null | undefined) {
    if (!geom) return;

    if (geom.type === 'GeometryCollection') {
      (geom as GeometryCollection).geometries.forEach(processGeometry);
    } else {
      processCoords(geom.coordinates);
    }
  }

  if ((geojson as FeatureCollection).type === 'FeatureCollection') {
    (geojson as FeatureCollection).features.forEach((f) => processGeometry(f.geometry));
  } else if ((geojson as Feature).type === 'Feature') {
    processGeometry((geojson as Feature).geometry);
  } else {
    processGeometry(geojson as Geometry);
  }
  return {
    eastLng: maxLng,
    northLat: maxLat,
    southLat: minLat,
    westLng: minLng,
  };
}
